<!--
  功能：巨量视频分析
  作者：lost
  邮箱：lost@daoyoudao.com
  时间：2021年08月09日 12:54:18
  版本：v1.0
-->
<template>
  <div v-if="this.$route.path == '/report/statistics/videoAnalysis'" class="videoAnalysis">
    <div class="page-title">巨量视频分析</div>
    <!-- 表单查询 -->
    <el-form ref="queryFormRef" class="query-form" :model="queryForm" :inline="true">
      <el-row type="flex" justify="space-between">
        <el-col :span="21">
          <div class="topdiv">
            <el-form-item label="日期范围">
              <el-date-picker
                @change="changeTime"
                v-model="timeDate"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
            <!-- <el-form-item label="投放账号">
              <el-select @change="accountChange" v-model="queryForm.agentAccountId" collapse-tags filterable clearable placeholder="请选择投放账号" style="width: 220px">
                <el-option v-for="item in accountList" :key="item.agentAccountId" :label="item.agentAccountName" :value="item.agentAccountId"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="视频类型">
              <el-select @change="videoTypeChange" v-model="queryForm.agentImageMode" collapse-tags filterable clearable placeholder="请选择视频类型" style="width: 180px">
                <el-option v-for="item in materialData" :key="item.value" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="3">
          <el-button icon="iconfont icon-zidingyiguanli-copy" size="medium" style="margin-right: 13px;" type="primary" @click="showColDialog">
            自定义列
          </el-button>
        </el-col>
      </el-row>
    </el-form>
    <!-- 表格 -->
    <el-table class="tableBox roleTable" :data="allData.pageData" v-loading="tableLoading" border style="width: 100%">
      <el-table-column label="视频" min-width="100px" prop="reportDate" fixed>
        <template slot-scope="scope">
          <div v-if="scope.$index !== 0">
            <div class="imgbox">
              <el-popover @hide="hideVideo(scope)"
              placement="right" trigger="hover" @show="showVideo(scope)" :width="260">
                <div class="img-box" style="width:100%; height:auto;background-color:#fff;">
                  <video :src="scope.row.url" style="width:100%;height:100%" :ref="`videoPl-${scope.$index}s`"
                  controls preload="auto" loop muted>您的浏览器不支持视频播放</video>
                </div>
                <div class="img-box margin10" slot="reference">
                  <img :src="scope.row.agentUrl" alt="" />
                  <div class="video"><i class="iconfont icon-sanjiao"></i></div>
                </div>
              </el-popover>
              <p class="multiple-line"></p>
            </div>
          </div>
          <div v-else>{{ scope.row.agentUrl }}</div>
        </template>
      </el-table-column>
      <el-table-column label="视频类型" min-width="88px" prop="agentImageMode">
        <template slot-scope="scope">
          <div>{{ materialArr[scope.row.agentImageMode] }}</div>
        </template>
      </el-table-column>
      <el-table-column label="日期" min-width="100px" prop="reportDate"></el-table-column>
      <el-table-column label="素材ID" min-width="120px" prop="agentMaterialId"></el-table-column>
      <el-table-column label="关联账户" min-width="88px" prop="accountCount">
        <template slot-scope="scope">
          <div v-if="scope.$index!=0">
            <el-popover :disabled="scope.row.accountNames && scope.row.accountNames.length === 0" placement="top" width="300" trigger="hover">
              <div class="popo-box">
                <p v-for="(item, index) in scope.row.accountNames" :key="index">{{ item }}</p>
              </div>
              <p slot="reference" class="cursor">{{ scope.row.accountNames.length }}个</p>
            </el-popover>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="关联计划" min-width="88px" prop="adCount">
        <template slot-scope="scope">
          <div v-if="scope.$index!=0">
            <el-popover :disabled="scope.row.adCountNames && scope.row.adCountNames.length === 0" placement="top" width="300" trigger="hover">
              <div class="popo-box">
                <p v-for="(item, index) in scope.row.adCountNames" :key="index">{{ item }}</p>
              </div>
              <p slot="reference" class="cursor">{{ scope.row.adCountNames.length }}个</p>
            </el-popover>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="关联创意" min-width="88px" prop="creativeCount">
        <template slot-scope="scope">
          <div v-if="scope.$index!=0">
            <el-popover :disabled="scope.row.creativeCountNames && scope.row.creativeCountNames.length === 0" placement="top" width="300" trigger="hover">
              <div class="popo-box">
                <p v-for="(item, index) in scope.row.creativeCountNames" :key="index">{{ item }}</p>
              </div>
              <p slot="reference" class="cursor">{{ scope.row.creativeCountNames.length }}个</p>
            </el-popover>
          </div>
        </template>
      </el-table-column>
      <el-table-column v-for="(col, index) in allData.headerData" :fixed="col.fixed" :prop="col.dictValue" :label="col.dictName" :key="index" min-width="90px"></el-table-column>
      <el-table-column v-if="allData.pageData.length !== 0" label="操作" min-width="148px" prop="reportDate" fixed="right">
        <template slot-scope="scope">
          <div v-if="scope.$index != 0">
            <el-button @click="accountDetails(scope.row)" type="text" size="small">账户详情</el-button>
            <el-button @click="creativeDetails(scope.row)" type="text" size="small">创意详情</el-button>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="paging-box" v-if="pageTotal > 0">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="queryForm.pageNum"
        :page-sizes="[10, 20, 40, 80, 100]"
        @size-change="handleSizeChange"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="pageTotal"
      ></el-pagination>
    </div>
    <!-- 自定义列对话框 -->
    <set-column :colsDialogFlag.sync="colsDialogFlag" @dragEnd="dragEnd" :leftMenu="false" :listdata="listdata" :checkedList="checkedList"></set-column>
  </div>
  <router-view v-else></router-view>
</template>

<script>
import { handleTimeNew } from '@/components/public'
import setColumn from '@/components/setColumn'
export default {
  // 组件名称
  name: 'videoAnalysis',
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: { setColumn },
  // 组件状态值
  data() {
    return {
      accountList: [], // 投放账户
      tableLoading: false,
      itemkey: 10012,
      timeDate: [handleTimeNew(new Date()), handleTimeNew(new Date())],
      materialData: [
        {
          value: 'CREATIVE_IMAGE_MODE_VIDEO',
          name: '横版视频'
        },
        {
          value: 'CREATIVE_IMAGE_MODE_VIDEO_VERTICAL',
          name: '竖版视频'
        }
      ],
      materialArr: {
        // 素材类型展示
        CREATIVE_IMAGE_MODE_VIDEO: '横版视频',
        CREATIVE_IMAGE_MODE_VIDEO_VERTICAL: '竖版视频'
      },
      queryForm: {
        // agentAccountId: '',
        agentImageMode: '',
        startDate: handleTimeNew(new Date()),
        endDate: handleTimeNew(new Date()),
        // startDate: '2020-08-01',
        // endDate: '2021-09-04',
        // 分页
        pageNum: 1,
        pageSize: 10 // 每页显示的数据条数
      },
      // 分页
      pageTotal: 0,
      // 自定义列对话框
      colsDialogFlag: false,
      editBtn: true, // 自定义列应用按钮显示隐藏
      // 勾选上的列表
      checkedList: [],
      listdata: [],
      // 表格数据
      allData: {
        headerData: [],
        pageData: []
      }
    }
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {
    $route(to) {
      if (this.$route.path === '/report/statistics/videoAnalysis') {
        this.getvideoList()
      }
    }
  },
  // 组件方法
  methods: {
    accountDetails(row) {
      this.$router.push({ name: 'videoAccountDetails', query: { id: row.agentMaterialId, time: row.reportDate } })
    },
    creativeDetails(row) {
      this.$router.push({ name: 'videoCreativeDetails', query: { id: row.agentMaterialId, time: row.reportDate } })
    },
    accountChange() {
      this.getvideoList()
    },
    videoTypeChange() {
      this.getvideoList()
    },
    changeTime() {
      console.log(this.timeDate)
      if (this.timeDate) {
        this.queryForm.startDate = this.timeDate[0]
        this.queryForm.endDate = this.timeDate[1]
        this.queryForm.pageNum = 1
      } else {
        this.queryForm.startDate = ''
        this.queryForm.endDate = ''
      }
      this.getvideoList()
    },
    // 点击确定，获取拖动排序的列表
    dragEnd() {
      console.log(JSON.stringify(this.checkedList, null, '\t'))
      let jsonData = {
        columnDetailData: this.checkedList
      }
      this.$service.post('/api/analyse/applyVideoCustomColumn', jsonData).then(res => {
        if (res.code === 200) {
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
          this.changeTime()
        }
      })
      // 隐藏对话框
      this.colsDialogFlag = false
    },
    // 获取数据
    async getvideoList() {
      try {
        this.tableLoading = true
        this.allData.headerData = []
        this.allData.pageData = []
        const { result } = await this.$service.post('/api/analyse/jl/video/list', this.queryForm)
        if (result) {
          this.allData = result
          this.pageTotal = result.total
          if (this.allData.pageData && this.allData.pageData.length) {
            this.allData.pageData.forEach((item, index) => {
              if (index !== 0) {
                // item.url = item.domain + item.url
                item.accountNames = this.strToArr(item.accountNames)
                item.adCountNames = this.strToArr(item.adCountNames)
                item.creativeCountNames = this.strToArr(item.creativeCountNames)
              }
              item.validPlayRate = item.validPlayRate + '%'
              item.playOverRate = item.playOverRate + '%'
              item.wifiPlayRate = item.wifiPlayRate + '%'
            })
          }
        }
      } catch (error) {
        console.log('getvideoList', error)
      } finally {
        this.tableLoading = false
      }
    },
    // 字符串截取转化为数组
    strToArr(str) {
      let arr = []
      arr = str
        .trim()
        .substring(0, str.length - 1)
        .split('#,')
      // console.log('arr', arr)
      return arr || []
    },
    // 弹出层展示开始播放视频
    showVideo(scope) {
      const video = this.$refs[`videoPl-${scope.$index}s`]
      video.play()
      this.$nextTick(() => {
      })
    },
    // 弹出层隐藏暂停播放视频
    hideVideo(scope) {
      const video = this.$refs[`videoPl-${scope.$index}s`]
      video.pause()
    },
    /*
     * 自定义列的对话框
     */
    // 显示自定义列对话框
    showColDialog() {
      this.checkedList = [] // 清空选中的列
      this.$service
        .post('/api/analyse/videoCustomColumnList')
        .then(res => {
          if (res.code === 200) {
            this.listdata = res.result.columnData
            this.checkedList = res.result.columnOrderData
            this.colsDialogFlag = true
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 切换分页
    handleCurrentChange(val) {
      this.getvideoList()
    },
    // 切换数据显示条数
    handleSizeChange(size) {
      this.queryForm.pageSize = size
      this.getvideoList()
    }
  },
  // 组件在内存中被创建
  created() {
    if (this.$route.path === '/report/statistics/videoAnalysis') {
      // this.getAccountList4Select() // 获取投放账户
      this.getvideoList()
    }
  },
  /**
   * 组件被渲染到页面
   */
  mounted() {}
}
</script>

<style lang="less" scoped>
.videoAnalysis {
  /deep/ .roleTable {
    .el-table__fixed {
      z-index: 11;
    }
    .el-table__fixed-right {
      z-index: 11;
    }
  }
  .margin10 {
    margin: 10px 0;
  }
  // 图片放大
  .img-box {
    width: 80px;
    height: 45px;
    border-radius: 3px;
    background-color: rgba(0, 0, 0, 0.8);
    overflow: hidden;
    display: flex;
    position: relative;
    .item-img {
      flex: 1;
      margin-left: 2px;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      text-align: center;
    }
    img {
      max-width: 100%;
      max-height: 100%;
      // width: 80px;
      // height: 45px;
      margin: auto;
    }
    .video {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      width: 20px;
      height: 20px;
      line-height: 18px;
      text-align: center;
      border: 1px solid #fff;
      border-radius: 50%;
      color: #fff;
      .icon-sanjiao {
        font-size: 13px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/analyze/videoAnalysis.vue